import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlayerClassesComponent } from './containers/player-classes/player-classes.component';
import { PlayerSkillsComponent } from './containers/player-skills/player-skills.component';
import { TrapsComponent } from './containers/traps/traps.component';
import { MonstersComponent } from './containers/monsters/monsters.component';
import { PlayThroughComponent } from './containers/play-through/play-through.component';
import { StatisticsComponent } from './containers/statistics/statistics.component';
import { InventoryItemsComponent } from './containers/inventory-items/inventory-items.component';
import { InventoryManagementComponent } from './containers/inventory-management/inventory-management.component';
import { BlacksmithComponent } from './containers/blacksmith/blacksmith.component';
import { RecruiterComponent } from './containers/recruiter/recruiter.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'statistics' },
  { path: 'statistics', component: StatisticsComponent },
  { path: 'classes', component: PlayerClassesComponent },
  { path: 'skills', component: PlayerSkillsComponent },
  { path: 'traps', component: TrapsComponent },
  { path: 'monsters', component: MonstersComponent },
  { path: 'items', component: InventoryItemsComponent },
  { path: 'play', component: PlayThroughComponent },
  { path: 'inventory', component: InventoryManagementComponent },
  { path: 'recruiter', component: RecruiterComponent },
  { path: 'blacksmith', component: BlacksmithComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
